// extracted by mini-css-extract-plugin
export default {"mainContainer":"Main_mainContainer__Pe-OZ","tappoContainer":"Main_tappoContainer__xuT1p","alertContainer":"Main_alertContainer__ExUuo","bigH1":"Main_bigH1__UaZsu"};